import { ref } from 'vue'
import { request, tokenStorageKey } from '@/api/userAuth'

import { beginLoginTransfer } from '@/composables/loginTransfer'

export const currentUser = ref(null)
export const hasLogin = ref(Boolean(localStorage.getItem(tokenStorageKey)))
let expiryTimer
let pendingLoad
let pendingLogout
let sessionVersion = 0

function clearUser() {
  sessionVersion += 1
  clearTimeout(expiryTimer)
  currentUser.value = null
  hasLogin.value = false
  localStorage.removeItem(tokenStorageKey)
}
window.addEventListener('weijie-auth-expired', clearUser)
window.addEventListener('weijie-login-transfer', clearUser)

export function applyUserSession(data) {
  const expiresIn = Number(data.auth?.expires_in)
  if (!Number.isFinite(expiresIn) || expiresIn <= 0) { clearUser(); throw new Error('登录已过期，请重新登录') }
  clearTimeout(expiryTimer)
  currentUser.value = data.user
  if (data.access_token) localStorage.setItem(tokenStorageKey, data.access_token)
  hasLogin.value = Boolean(localStorage.getItem(tokenStorageKey))
  const deadline = Date.now() + Math.max(0, expiresIn * 1000)
  const scheduleExpiry = () => {
    const remaining = deadline - Date.now()
    if (remaining <= 0) {
      clearUser()
      // The server clears the HttpOnly cookie; checking does not renew the token.
      // eslint-disable-next-line no-use-before-define
      loadUser().catch(() => {
        window.dispatchEvent(new CustomEvent('weijie-auth-expired'))
      })
      return
    }
    expiryTimer = setTimeout(scheduleExpiry, Math.min(remaining + 100, 2147483647))
  }
  const delay = Math.min(Math.max(deadline - Date.now(), 0) + 100, 2147483647)
  expiryTimer = setTimeout(scheduleExpiry, delay)
}

export async function loadUser() {
  if (currentUser.value) return currentUser.value
  if (!pendingLoad) {
    const version = sessionVersion
    pendingLoad = request('me')
      .then((data) => {
        if (version !== sessionVersion) throw new Error('登录状态已改变')
        if (data.transfer) {
          beginLoginTransfer(data.transfer)
          const error = new Error('正在跳转到所属站点')
          error.code = 'LOGIN_REDIRECT'
          throw error
        }
        applyUserSession(data)
        return data.user
      })
      .catch((error) => {
        if (version === sessionVersion) clearUser()
        throw error
      })
      .finally(() => { pendingLoad = null })
  }
  return pendingLoad
}
export async function logoutUser() {
  if (!pendingLogout) {
    pendingLogout = (async () => {
      await request('logout', {})
      clearUser()
      // Finish any earlier session check before the login route checks the cleared Cookie.
      await pendingLoad?.catch(() => {})
    })().finally(() => { pendingLogout = null })
  }
  return pendingLogout
}
